import { Box, Typography } from "@mui/material";
import { useIsMobileView } from "../../utils/responsive";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";
import SettingsMenu from "../configuration/SettingsMenu";


export const ConfigurationPage = () => {

    const selectedRaffle = useAppSelector(
      ({ selectedRaffle }: RootState) => selectedRaffle,
    );
  

  const isMobileView = useIsMobileView();

  return (
    <Box 
      paddingX={isMobileView ? 1 : 10} 
      marginTop={2}
      sx={{ 
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden"
      }}
    >
      <Typography 
        variant={isMobileView ? "h6" : "h5"} 
        fontFamily={"Georgia"} 
        paddingBottom={2}
        paddingX={isMobileView ? 1 : 0}
        fontSize={isMobileView ? "1.1rem" : "1.5rem"}
      >
        Configuración de rifa <strong>{selectedRaffle.name}</strong>
      </Typography>
      <Box mx={isMobileView ? 0 : 10} sx={{ width: "100%" }}>
        {selectedRaffle.id === 'default' ? null : <SettingsMenu raffle={selectedRaffle} />}
      </Box>
    </Box>
  );
};
